import resellersModule from "../resellersModule.js";
import { EnvironmentUrls } from "Roblox";

const resellersConstants = {
    urls: {
        getResellers: EnvironmentUrls.economyApi + "/v1/assets/{assetId}/resellers",
        getResaleData: EnvironmentUrls.economyApi + "/v1/assets/{assetId}/resale-data",
        getOwnedResaleCopies: EnvironmentUrls.economyApi + "/v1/assets/{assetId}/users/{userId}/resale-copies"
    },

    resaleChartDayOptions: [30, 90, 180],

    translationKeys: {
        notAvailable: "Label.NotAvailable"
    },

    highCharts: {
        marginLeft: 50,
        lineChartHeight: 130,
        verticalBarChartHeight: 50,
        itemDelimiter: ",",
        lineDelimiter: "|",
        colors: {
            backgroundColor: "transparent",
            lineColor: "#02b757",
            verticalBarColor: "#b8b8b8",
            borderColor: "#757575",
            pointColor: "#fff"
        }
    },

    errorCodes: {
        internal: {
            unknown: 0
        },
        economyApi: {}
    }
};

resellersConstants.highCharts.defaultConfiguration = {
    chart: {
        backgroundColor: resellersConstants.highCharts.colors.backgroundColor,
        marginLeft: resellersConstants.highCharts.marginLeft,
    },
    title: {
        text: ""
    },
    legend: {
        enabled: false
    },
    tooltip: {
        backgroundColor: resellersConstants.highCharts.colors.borderColor,
        borderColor: resellersConstants.highCharts.colors.borderColor,
        pointFormat: `<span style="color:${resellersConstants.highCharts.colors.pointColor}">{point.y}</span>`,
        headerFormat: ""
    },
    xAxis: {
        type: "datetime",
        max: new Date().getTime(),
        tickLength: 0
    },
    credits: {
        enabled: false
    }
};

resellersModule.constant("resellersConstants", resellersConstants);
export default resellersConstants;